import { type ChangeEvent } from "react";

import { type SwitchProps } from "ui/switch/switch.types";

type UseSwitchProps = Pick<SwitchProps, "toggleName" | "onChange">;

const FALLBACK_NAME = "Toggle";

export const useSwitch = ({ toggleName, onChange }: UseSwitchProps) => {
  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    onChange?.(event.target.checked);
  };

  return {
    hasLabel: Boolean(toggleName),
    accessibleName: toggleName || FALLBACK_NAME,
    handleChange,
  };
};
